import {
    Tabs,
    TabsContent,
    TabsList,
    TabsTrigger,
} from "../ui/tabs";

import CommunicationsSubscribers from "./CommunicationsSubscribers";
import CommunicationsEmailTemplates from "./CommunicationsEmailTemplates";

export default function CommunicationsTabs() {
    return (
        <Tabs defaultValue="email-templates" className="w-full">
            <TabsList className="grid w-full grid-cols-2 mb-6">
                <TabsTrigger value="email-templates">Email Templates</TabsTrigger>
                <TabsTrigger value="subscribers">Subscribers</TabsTrigger>
            </TabsList>
            <TabsContent value="email-templates">
                <CommunicationsEmailTemplates />
            </TabsContent>
            <TabsContent value="subscribers">
                <CommunicationsSubscribers />
            </TabsContent>
        </Tabs>
    );
}

